export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CLOSE_PAGE = 'CLOSE_PAGE'
export const ADD_OVERLAY_PAGE = 'ADD_OVERLAY_PAGE'
export const VIEW_STOMPUNKT = 'VIEW_STOMPUNKT'

export const CLEAR_SELECTION = 'CLEAR_SELECTION'
export const CLEAR_STOMPUNKT = 'CLEAR_STOMPUNKT'
export const REMOVE_SELECTED = 'REMOVE_SELECTED'
export const TOGGLE_CURRENT_STOMPUNKT = 'TOGGLE_CURRENT_STOMPUNKT'
export const TOGGLE_STOMPUNKT = 'TOGGLE_STOMPUNKT'
export const ZOOMIN_STOMPUNKT = 'ZOOMIN_STOMPUNKT'
export const SELECT_WITH_POLYGON = 'SELECT_WITH_POLYGON'
export const TOGGLE_POLYGON_MODE = 'TOGGLE_POLYGON_MODE'

export const CHANGE_LAYOUT = 'CHANGE_LAYOUT'

export const LOAD_LIGHT_STOMPUNKTER_REQUEST = 'LOAD_LIGHT_STOMPUNKTER_REQUEST'
export const LOAD_LIGHT_STOMPUNKTER_ERROR = 'LOAD_LIGHT_STOMPUNKTER_ERROR'
export const LOAD_LIGHT_STOMPUNKTER_SUCCESS = 'LOAD_LIGHT_STOMPUNKTER_SUCCESS'

export const LOAD_HEAVY_STOMPUNKTER_REQUEST = 'LOAD_HEAVY_STOMPUNKTER_REQUEST'
export const LOAD_HEAVY_STOMPUNKTER_ERROR = 'LOAD_HEAVY_STOMPUNKTER_ERROR'
export const LOAD_HEAVY_STOMPUNKTER_SUCCESS = 'LOAD_HEAVY_STOMPUNKTER_SUCCESS'

export const TOGGLE_FILTER = 'TOGGLE_FILTER'

export const UPDATE_BOUNDS = 'UPDATE_BOUNDS'
export const ZOOM_IN = 'ZOOM_IN'
export const ZOOM_OUT = 'ZOOM_OUT'
export const ZOOM_TO_LAT_LNG = 'ZOOM_TO_LAT_LNG'
export const ZOOM_TO_CURRENT_STOMPUNKT = 'ZOOM_TO_CURRENT_STOMPUNKT'
export const CHANGE_BASEMAP = 'CHANGE_BASEMAP'

export const OPEN_SEARCH = 'OPEN_SEARCH'
export const CLOSE_SEARCH = 'CLOSE_SEARCH'
export const CHANGE_SEARCH_TERM = 'CHANGE_SEARCH_TERM'

export const TOGGLE_PERMALINK = 'TOGGLE_PERMALINK'

export const CHANGE_EXPORT_FORMAT = 'CHANGE_EXPORT_FORMAT'
export const TOGGLE_EXPORT_FIELD = 'TOGGLE_EXPORT_FIELD'
export const START_EXPORTING = 'START_EXPORTING'
export const DONE_EXPORTING = 'DONE_EXPORTING'
export const OPEN_PDF = 'OPEN_PDF'

export const CHANGE_SRID = 'CHANGE_SRID'

export const SELECTION_PAGINATION_PREVIOUS = 'SELECTION_PAGINATION_PREVIOUS'
export const SELECTION_PAGINATION_NEXT = 'SELECTION_PAGINATION_NEXT'

export const HIDE_LEGAL_DIALOG = 'HIDE_LEGAL_DIALOG'

export const TOGGLE_LABELS = 'TOGGLE_LABELS'



// WEBPACK FOOTER //
// ./src/constants/actions.js